import 'css-chunksrc/client/scenes/notifications/notification/addedToEvent/styles.scss';export default {
  "notification": "_notification_37ryp_1",
  "header": "_header_37ryp_8",
  "date": "_date_37ryp_18",
  "main": "_main_37ryp_24",
  "author": "_author_37ryp_28",
  "avatar": "_avatar_37ryp_38",
  "authorName": "_authorName_37ryp_43",
  "text": "_text_37ryp_49",
  "content": "_content_37ryp_56",
  "mention": "_mention_37ryp_63",
  "task": "_task_37ryp_67"
};